const getPictureFromFacebook = async () => {
    throw new Error('Facebook not implemented on web');
};

export default getPictureFromFacebook;
